import AboutPblDefault from '../components/about/subpages/AboutPblDefault.js';
import AboutPblExamples from '../components/about/subpages/AboutPblExamples.js';

export default [
    {
        id: 1,
        name: 'what-is',
        component: AboutPblDefault,
        menu_order: 1,
    },
    {
        id: 2,
        name: 'how-search',
        component: AboutPblDefault,
        menu_order: 2,
    },
    {
        id: 3,
        name: 'what-in',
        component: AboutPblDefault,
        menu_order: 3,
        children: [
            {
                id: 31,
                name: 'examples',
                component: AboutPblExamples
            }
        ]
    },
    {
        id: 11,
        name: 'publications-about-pbl',
        component: AboutPblDefault,
        menu_order: 4,
    },
    {
        id: 4,
        name: 'how-create',
        component: AboutPblDefault,
        menu_order: 5,
    },
    {
        id: 5,
        name: 'source',
        component: AboutPblDefault,
        menu_order: 6
    },
    {
        id: 6,
        name: 'conditions',
        component: AboutPblDefault,
        menu_order: 7,
        children: [
            {
                id: 61,
                name: 'api-docs',
                component: AboutPblDefault
            }
        ]
    },
    {
        id: 7,
        name: 'team',
        component: AboutPblDefault,
        menu_order: 8,
    },
    {
        id: 8,
        name: 'contact',
        component: AboutPblDefault,
        menu_order: 9,
    },
    {
        id: 9,
        name: 'privacy-policy',
        component: AboutPblDefault,
        menu_order: 10,
    },
    {
        id: 10,
        name: 'accessibility',
        component: AboutPblDefault,
        menu_order: 11,
    },
    {
	id: 12,
	name: 'pbl-in-knowledge-graph',
	component: AboutPblDefault
    },
];



// WEBPACK FOOTER //
// ./src/scripts/AboutSubpages.js